module.exports = __webpack_public_path__ + "static/img/equipmentB.e413e528.png";